import {TelefoneSuper} from './telefone-super';
import {Telefone} from './telefone';
import {Construtor} from './construtor';

export class TelefoneCliente extends TelefoneSuper implements Construtor<TelefoneCliente> {

  public idTelefoneCliente: number;

  public idCliente: number;

  public alterado: boolean;

  constructor(object?: any) {
    super();
    this.telefone = new Telefone();
    if (object !== undefined) {

      if (object instanceof TelefoneCliente) {
        this.copyObject(object);
      } else if (object instanceof Telefone) {
        this.Telefone = object;
      } else {
        this.parseFromJson(object);
      }
    }
    return this;
  }

  get obterIdTelefoneCliente(): number {
    return this.idTelefoneCliente;
  }

  set IdTelefoneCliente(idTelefoneCliente: any) {
    this.idTelefoneCliente = idTelefoneCliente;
  }

  copyObject(telefoneCliente: TelefoneCliente): void {
    this.idTelefoneCliente = telefoneCliente.idTelefoneCliente;
	this.telefone = telefoneCliente.telefone;
	this.idCliente = telefoneCliente.idCliente;
  }

  parseFromJson(telefoneCliente: any): void {
    this.IdTelefoneCliente = telefoneCliente.idTelefoneCliente;
    this.Telefone = telefoneCliente.telefone;
	this.idCliente = telefoneCliente.idCliente;
  }

  getNewInstance(object?: any): TelefoneCliente {
    return new TelefoneCliente(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/telefone-cliente.ts